export default "__VITE_ASSET__cE7X0UgT__"